import Vue from "vue";
import VueRouter from "vue-router";
// import { URLS } from "fire-wind-water";
// import { common } from "@/model/common";
const includPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return includPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
const routes = [
  {
    path: "",
    redirect: "/auth",
  },
  {
    path: "/auth",
    component: () => import("../views/auth"),
  },
  {
    path: "/pc",
    component: () => import("../views/pc"),
    children: [
      {
        path: "/",
        redirect: "/pc_login",
      },
      {
        path: "/pc_login",
        component: () => import("../views/pc/login"),
      },
      {
        path: "/pc_register",
        component: () => import("../views/pc/register"),
      },
      {
        path: "/pc_short",
        component: () => import("../views/pc/short"),
      },
      {
        path: "/pc_bindRegister",
        component: () => import("../views/pc/bind-register"),
      },
      {
        path: "/pc_bindLogin",
        component: () => import("../views/pc/bind-login"),
      },
      {
        path: "/pc_increase",
        component: () => import("../views/pc/increase"),
      },
      {
        path: "/pc_loginSuccess",
        component: () => import("../views/pc/login-success"),
      },
      {
        path: "/pc_noPassword",
        component: () => import("../views/pc/no-password"),
      },
      {
        path: "/pc_passwordTip",
        component: () => import("../views/pc/password-tip"),
      },
      {
        path: "/pc_phoneRegister",
        component: () => import("../views/pc/phone-register"),
      },
      {
        path: "/pc_retrievePassword",
        component: () => import("../views/pc/retrieve-password"),
      },
      {
        path: "/pc_setPassword",
        component: () => import("../views/pc/set-password"),
      },
      {
        path: "/pc_null",
        component: () => import("../views/pc/null"),
      },
    ],
  },
  {
    path: "/wap",
    component: () => import("../views/wap"),
    children: [
      {
        path: "/",
        redirect: "/wap_login",
      },
      {
        path: "/wap_login",
        component: () => import("../views/wap/login"),
      },
      {
        path: "/wap_register",
        component: () => import("../views/wap/register"),
      },
      {
        path: "/wap_short",
        component: () => import("../views/wap/short"),
      },
      {
        path: "/wap_bindRegister",
        component: () => import("../views/wap/bind-register"),
      },
      {
        path: "/wap_bindLogin",
        component: () => import("../views/wap/bind-login"),
      },
      {
        path: "/wap_increase",
        component: () => import("../views/wap/increase"),
      },
      {
        path: "/wap_loginSuccess",
        component: () => import("../views/wap/login-success"),
      },
      {
        path: "/wap_noPassword",
        component: () => import("../views/wap/no-password"),
      },
      {
        path: "/wap_passwordTip",
        component: () => import("../views/wap/password-tip"),
      },
      {
        path: "/wap_phoneRegister",
        component: () => import("../views/wap/phone-register"),
      },
      {
        path: "/wap_retrievePassword",
        component: () => import("../views/wap/retrieve-password"),
      },
      {
        path: "/wap_setPassword",
        component: () => import("../views/wap/set-password"),
      },
      {
        path: "/wap_null",
        component: () => import("../views/wap/null"),
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  routes,
});
// 匹配当前环境 路由重定向
// if (!URLS.getURL("isSetting")) {
//   router.beforeEach((to, from, next) => {
//     if (common.isMobile && to.path.includes("pc")) {
//       next({ path: "wap_" + to.path.split("_")[1], query: { ...to.query } });
//     }
//     if (!common.isMobile && to.path.includes("wap")) {
//       next({ path: "pc_" + to.path.split("_")[1], query: { ...to.query } });
//     }
//     next();
//   });
// }
export default router;
